import {
  SubscribeStepperComponent,
  DataFlowEnum,
  type SubscribeEventPaylod,
} from '@commerce-subscription-webcomponents/ui';
import { IProduct } from '@commerce-product-webcomponents/sdk';
import { SubscribeButtonPropTypes, SubscribeStepperPropTypes } from './types/propTypes';

const SubscribeStepper = (props: SubscribeStepperPropTypes) => {
  const { productData, ...restProps } = props;

  const { productId, productType } = productData as IProduct;

  return <SubscribeStepperComponent productId={productId} productType={productType} {...restProps} />;
};

export { DataFlowEnum };
export type { SubscribeButtonPropTypes, SubscribeEventPaylod };
export default SubscribeStepper;
